import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { useEffect, useState } from "react";

const ContentSkeleton = ({ variant = "default" }) => {
  const [isMounted, setIsMounted] = useState(false);

  const isVerticalFeed = variant === "vertical-feed";
  const heights = [
    150, 200, 300, 250, 400, 350, 200, 300, 450, 250, 150, 350, 340,
  ];
  const items = isVerticalFeed ? Array.from({ length: 12 }) : heights;

  // Delay rendering Masonry to avoid layout shift
  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), 100); // Adjust the delay as needed
    return () => clearTimeout(timeout);
  }, []);

  if (!isMounted) return null; // Render nothing before it's mounted

  return (
    <ResponsiveMasonry
      columnsCountBreakPoints={{ 350: 2, 750: 3, 1024: 5 }}
      gutterBreakPoints={{ 350: "15px", 750: "14px", 1024: "22px" }}
    >
      <Masonry
        containerTag="div"
        itemTag="div"
        itemStyle={{ gap: isVerticalFeed ? "var(--play-card-gap-y, 14px)" : undefined }}
        sequential={true}
      >
        {items.map((height, index) => (
          <div key={index} className="flex flex-col overflow-hidden w-full">
            {/* Image Placeholder */}
            <div
              style={isVerticalFeed ? undefined : { height }}
              className={`w-full bg-zinc-200 dark:bg-light_secondary_label animate-pulse ${isVerticalFeed ? "aspect-[3/4] rounded-xl" : "rounded-2xl"}`}
            />
            {/* Title Placeholder */}
            <div className="h-6 bg-zinc-200 dark:bg-light_secondary_label animate-pulse rounded-md mt-2" />
            {/* Avatar and Likes Placeholder */}
            <div className="flex justify-between items-center mt-2">
              <div className="flex items-center gap-2">
                <div className="h-6 w-6 bg-zinc-200 dark:bg-light_secondary_label animate-pulse rounded-full" />
                <div className="h-6 w-10 bg-zinc-200 dark:bg-light_secondary_label animate-pulse rounded-md" />
              </div>
              <div className="h-6 w-16 bg-zinc-200 dark:bg-light_secondary_label animate-pulse rounded-md" />
            </div>
          </div>
        ))}
      </Masonry>
    </ResponsiveMasonry>
  );
};

export default ContentSkeleton;
